module.exports = __webpack_public_path__ + "img/hook_KITO_HJJ_4.d622f42a.png";